import Button from '../../Buttons';
import InputField from '../../Form/InputField';
import SelectField from '../../Form/SelectField';
import Icon from '../../Icon';
import Section from '../Section';
import { FC, FormEvent } from 'react';

type Props = {
	states: { value: string; label: string }[];
	cities: { value: string; label: string }[];
	search: string;
	setSearch: (value: string) => void;
	selectedState: string;
	setSelectedState: (value: string) => void;
	selectedCity: string;
	setSelectedCity: (value: string) => void;
	locationDisabled: boolean;
	showFilterButton?: boolean;
	onSearch: (e: FormEvent<HTMLFormElement>) => void;
	onFilterButtonPress: () => void;
};

const HomeTopSection: FC<Props> = ({
	cities,
	states,
	search,
	setSearch,
	selectedState,
	setSelectedState,
	selectedCity,
	setSelectedCity,
	locationDisabled,
	showFilterButton = true,
	onSearch,
	onFilterButtonPress,
}) => {
	const handleSearchSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSearch(e);
	};

	return (
		<div className="w-full max-w-[896px] mx-auto px-0" id="busca">
			<form onSubmit={handleSearchSubmit} className="relative z-30">
				<div className="flex flex-col items-center gap-5 rounded-2xl border border-gray-100 bg-white p-5 shadow-lg md:h-[90px] md:flex-row md:gap-0 md:p-4">
					
					{/* Search Field */}
					<div className="flex items-center flex-1 w-full md:w-auto px-6 h-[64px] md:h-full relative group min-w-0">
						<Icon name="search" className="text-gray-400 text-[20px] absolute left-6 pointer-events-none group-focus-within:text-[#0F1DD7] transition-colors" />
						<input
							type="text"
							aria-label="Cargo, palavra-chave ou empresa"
							placeholder="Cargo, palavra-chave ou empresa"
							className="w-full h-full bg-transparent border-none focus:ring-0 text-sm md:text-base text-gray-800 pl-10 placeholder:text-gray-400 outline-none font-normal truncate"
							onChange={e => setSearch(e.target.value)}
							value={search}
						/>
					</div>

					{/* Location Field */}
					<div className="flex items-center flex-1 w-full md:w-auto px-6 h-[64px] md:h-full relative group min-w-0">
						<Icon name="location" className="text-gray-400 text-[20px] absolute left-6 pointer-events-none group-focus-within:text-[#0F1DD7] transition-colors" />
						<div className="flex-grow">
							<SelectField
								placeholder="Cidade, estado ou remoto"
								className="my-0 border-none shadow-none w-full"
								labelProps={{ className: 'hidden' }}
								unstyled={true}
								showArrow={false}
								inputProps={{
									className: 'border-none shadow-none h-full bg-transparent pl-10 focus:ring-0 text-sm md:text-base text-gray-800 focus:outline-none min-w-0 font-normal py-0 truncate',
								}}
								disabled={locationDisabled}
								setValue={setSelectedState as any}
								value={selectedState}
								initialValue={selectedState}
								options={states}
								required={true}
							/>
						</div>
					</div>

					{/* Search Button */}
					<div className="flex w-full justify-center pt-5 md:block md:w-auto md:pl-4 md:pt-0">
						<button
							type="submit"
							className="w-auto h-14 md:h-[56px] px-10 rounded-full font-bold text-lg text-white bg-[#0F1DD7] hover:bg-blue-800 transition-all flex items-center justify-center shadow-md hover:shadow-lg active:scale-95 whitespace-nowrap"
						>
							Buscar Vagas
						</button>
					</div>
				</div>

				{showFilterButton && (
					<div className="flex justify-center mt-6 md:hidden">
						<Button 
							variant="secondary" 
							className="rounded-full flex items-center gap-2 border-gray-200" 
							onClick={onFilterButtonPress}
						>
							<Icon name="filter" className="w-4 h-4" />
							Filtros Avançados
						</Button>
					</div>
				)}
			</form>
		</div>
	);
};

export default HomeTopSection;
